import { render, staticRenderFns } from "./JgpFromGroup.vue?vue&type=template&id=1d94a577&"
import script from "./JgpFromGroup.vue?vue&type=script&lang=js&"
export * from "./JgpFromGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports